import { render } from "./MainComponent.vue?vue&type=template&id=34aa67a4&scoped=true&ts=true"
import script from "./MainComponent.vue?vue&type=script&lang=ts"
export * from "./MainComponent.vue?vue&type=script&lang=ts"

import "./MainComponent.vue?vue&type=style&index=0&id=34aa67a4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aa67a4"]])

export default __exports__